// @ts-nocheck

import SeoTextArea from '../../../components/molecules/seoTextArea/SeoTextArea';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

function SeoSectionTastic({ data, context }) {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const { title, text, textAlign, titleStyles, textStyles } = data;

  return (
    <SeoTextArea
      title={title}
      text={text}
      textAlign={textAlign}
      titleStyles={titleStyles}
      textStyles={textStyles}
    />
  );
}

export default tastify({ translate: true, connect: { context: true } })(SeoSectionTastic);
